const CONFIG = {

    API_KEY:"63bf6ecd8c46c5.53082791"
}

export default CONFIG